import {useQuery} from '@tanstack/react-query'
import {useEffect} from 'react'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  cameraId: number
  onError?: (error: unknown) => void
  enabled?: boolean
  offsetStream?: number
}

export default function useStartStream({cameraId, onError, enabled = true, offsetStream}: Props) {
  const query = useQuery({
    enabled,
    retry: 0,
    queryKey: [QueryKeyEnum.START_STREAM, cameraId, offsetStream],
    queryFn: async () => {
      if (offsetStream) return api.streaming.startStreamWithCameraId(cameraId, offsetStream)
      const response = await api.streaming.getStream(cameraId)
      return api.streaming.startStream(response.data.data)
    },
  })

  useEffect(() => {
    if (query.isError) onError?.(query.error)
  }, [query.error])

  return query
}
